import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import getDeviceType from '../../../../utils/getDeviceType';
import getSku from '../../../../utils/getSku';
import { getInjector } from '../../utils/getInjector';

const CRITEO_DEVICE_TYPE_MAP = {
  pad: 't',
  phone: 'm',
  pc: 'd',
};

/**
 * @param {object} payload
 * @param {array} payload.cartItems - The items in cart.
 * @param {number} payload.subtotal - The subtotal of the cart.
 */
export const onTrackCartImpression = async (payload) => {
  const { cartItems, subtotal } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const mainConfig = injector.get('mainConfig');
  const Analytics = injector.get('Analytics');
  const gaService = injector.get('gaService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.CartImpression,
  });

  trackerService.fbInitiateCheckout(cartItems, subtotal);

  if (Analytics.configuration.enhancedEcommerce) {
    gaService.sendPageView();
  }

  const deviceType = getDeviceType();
  const items = cartItems.map((item) => ({
    id: getSku(
      item.id,
      item.product_sku,
      item.variation_id
        ? {
            ...item.variation,
            key: item.variation_id,
          }
        : undefined,
      item.settings,
    ),
    price: item.price?.dollars,
    quantity: item.quantity,
  }));
  window.criteo_q = window.criteo_q || [];
  window.criteo_q.push(
    { event: 'setAccount', account: mainConfig.criteoAccountId },
    { event: 'setHashedEmail', email: mainConfig.criteoEmail },
    { event: 'setSiteType', type: CRITEO_DEVICE_TYPE_MAP[deviceType] },
    { event: 'viewBasket', item: items },
  );
};
